/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:47:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-09-17 12:25:23
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/index.js
 * @Description: p1
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import Stage from '../components/Stage';
import setChart from './chart';
import Chart from '../components/Chart';
import { Title35 } from '../components/Titles';
import TooltipDrawer from '../components/TooltipDrawer';
import Form from './Form';

class P36 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartTitle: [],
      chartList: [],
      chartColorList: [],
    }
  }

  render() {
    const { chartTitle, chartList, chartColorList } = this.state;
    console.log(chartColorList)
    return (
      <Stage>
        <Title35 pageNumber="">1.5 伊利VS蒙牛 | 202308-202407单日数字品牌价值涨跌对比
        </Title35>

        <div className={s.content}>
          <div className={s.uiWrapper}>
              <div contentEditable className={s.unitText_1}>伊利VS蒙牛 单日数字品牌价值涨跌对比</div>
              <div contentEditable className={s.unitText_2}>来源：数字品牌榜</div>
              <div contentEditable className={s.unitText_2}>时间范围：2023.8.1-2024.7.31</div>
            <div className={s.chartWrapper}>
              <TooltipDrawer
                  style={{ width: '100%', height: '100%' }}
                  formContent={<Form onChange={values => this.setState({ ...values })} />}>
             
                  {/* <div contentEditable className={s.unitText_2}>单位：2023.8.1-2024.7.31</div> */}

                  <Chart options={setChart({
                    label: chartTitle,
                    list: chartList,
                    color: chartColorList
                  })} />
                  {/* <div contentEditable className={s.unitText_2}>单位: 条</div> */}
                </TooltipDrawer>
            </div>
          </div>
          <div contentEditable className={s.explain}>
            数据说明：本页图表数据观测窗口为2023年1月1日-12月31日。数据来源：新闻媒体类（中央级媒体/泛财经媒体/行业媒体/大众媒体）+资讯网媒+新闻客户端（今日头条/一点资讯等）+自媒体平台（微信号等）+社交平台（微博/知乎等）+短视频类（抖音/快手/视频号/B站等）+消费种草社区（小红书/什么值得买/得物App等）+垂类体育社区（虎扑/懂球帝/Keep等）+其它论坛贴吧等。
          </div>
        </div>
      </Stage>
    );
  }
}

export default withStyles(s)(P36);



// WEBPACK FOOTER //
// src/routes/visualChart/P36/index.js